module.exports = __webpack_public_path__ + "static/media/img-undo.723a0d39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/img-undo.svg
// module id = 32
// module chunks = 0